import LiquidRender from '@gate31/uikit/common/scripts/liquid-render';
import { discount } from '@gate31/types/order';
import EventBus from 'EventBus';
import { debounce } from 'lodash';
import { Base } from '@gate31/core/src/libs/BaseComponent';
import { RemoteCart } from '@gate31/feature/Cart/Cart';
import InsalesCart from 'Cart';
import { CartItemDesk } from '../../components/CartItemDesk/CartItemDesk';
import { CartLoyaltyDesk } from '../../components/CartLoyaltyDesk/CartLoyaltyDesk';
import { SnippetProductSliderDesk } from '../../components/SnippetProductSliderDesk/SnippetProductSliderDesk';
import { ProductsSliderDesk } from '../../components/ProductsSliderDesk/ProductsSliderDesk';

export class Cart extends Base<HTMLElement> {
    static cn = new Base.BuildCn('cart')

    cartItem: CartItemDesk;

    constructor(node: HTMLElement) {
        super(node);

        if (CartItemDesk.querySelectorAll(CartItemDesk.cn.toSelector()).length) {
            this.cartItem = new CartItemDesk(CartItemDesk.querySelector<HTMLDivElement>(CartItemDesk.cn.toSelector()));
        }

        this.connectionCallback();
    }

    connectionCallback() {
        EventBus.subscribe('delete_items:insales:cart', data => {
            this.cartItem.removeItem(data.action.items[0]);
        });

        EventBus.subscribe('update_items:insales:cart', data => {
            this.showCartOnLastUpdate(data.items_count);

            if (data.items_count === 0) {
                SnippetProductSliderDesk.init();
            } else {
                this.updateCartPrice({
                    discountObj: data.discounts[0],
                    totalPrice: data.total_price
                });
            }
        });

        EventBus.subscribe('sync-ready', () => {
            InsalesCart.forceUpdate();
        });

        EventBus.subscribe('set_items:insales:cart', () => {
            RemoteCart.updateRemoteCart();
        });

        // eslint-disable-next-line
        new CartLoyaltyDesk(CartLoyaltyDesk.querySelector(CartLoyaltyDesk.cn.toSelector()));
    }

    showCartOnLastUpdate = debounce((itemsCount: number) => {
        document.querySelector('.loader__wrap')?.classList.add('hidden');
        if (itemsCount === 0) {
            this.showEmptyCart();
        } else {
            this.renderCards();
            this.showMainCart();
        }
    }, 1600);

    showMainCart() {
        const mainContent = Cart.querySelector(Cart.cn.setElem('content').toSelector());
        const emptyContent = Cart.querySelector(Cart.cn.setElem('empty').toSelector());

        mainContent.classList.remove('hidden');
        emptyContent.classList.add('hidden');
    }

    showEmptyCart() {
        const mainContent = Cart.querySelector(Cart.cn.setElem('content').toSelector());
        const emptyContent = Cart.querySelector(Cart.cn.setElem('empty').toSelector());

        mainContent.classList.add('hidden');
        emptyContent.classList.remove('hidden');

        ProductsSliderDesk.init();
    }

    renderCards() {
        const order = InsalesCart.order.order_lines;
        const cartList = document.querySelector('.cart__order-list-wrapper');

        if (! cartList) return;

        const existingIds = new Set(
            Array.from(cartList.children as HTMLCollectionOf<HTMLElement>).map(el =>
                `${el.dataset.productId}-${el.dataset.itemId}`
            )
        );

        const itemsToRender = order.filter(item => {
            const key = `${item.product_id}-${item.variant_id}`;

            if (existingIds.delete(key)) {
                const qtyInput = document.querySelector(`[data-item-id="${item.variant_id}"] input`) as HTMLInputElement;
                const quantity = Number(qtyInput?.value);

                if (isFinite(quantity) && quantity !== item.quantity && quantity !== 0) {
                    document.querySelector(`[data-item-id="${item.variant_id}"]`)?.remove();
                    return true;
                }
                return false;
            }
            return true;
        });

        existingIds.forEach(key => {
            const [ productId, itemId ] = key.split('-');
            const selector = `[data-product-id="${productId}"][data-item-id="${itemId}"]`;

            document.querySelector(selector)?.remove();
        });

        itemsToRender.forEach(item => {
            const itemData = {
                item: {
                    id: item.id,
                    quantity: item.quantity,
                    sku: item.sku,
                    title: item.title,
                    image: { large_url: item.first_image?.large_url || '' },
                    product: {
                        id: item.product.id,
                        url: item.product.url,
                        variants: item.product.variants
                    }
                },
                settings: { cards_crop_off: '0' },
                messages: { cart_table_delete: 'Удалить товар из корзины' }
            };

            const html = LiquidRender.render('CartItemDesk', itemData);

            cartList.insertAdjacentHTML('beforeend', html);
        });

        //@ts-ignore
        if (itemsToRender.length) window.InSalesUI?.bindUpdateCart();
    }

    /**
     * Обновляем стоимость корзины
     * @param opts
     */
    updateCartPrice(opts: { discountObj: discount | undefined; totalPrice: number }): void {
        const wrapper = Cart.querySelector(Cart.cn.setElem('price-container').toSelector());
        const content = LiquidRender.render('cart-price-desktop-template', {
            discount: opts.discountObj,
            total_price: opts.totalPrice
        }) || '';

        wrapper.innerHTML = content;
    }
}
